import React from "react";
import { useSmartNavigate } from "@/hooks/use-smart-navigate";

const FacilityExpandLink = ({ id, action }) => {
  const { navigateToFacilityDetail } = useSmartNavigate();

  const handleClick = (e) => {
    e.stopPropagation();
    if (action) {
      navigateToFacilityDetail(id);
    }
  };

  return (
    <a onClick={handleClick}>
      <i className="fas fa-expand-arrows-alt text-lg"></i>
    </a>
  );
};

export default FacilityExpandLink;

